import React, { useRef } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./CardList.module.scss";

import { BookCard, BlogCard, CarousalArrow } from "../../common";

const settings = {
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow: 4,
  slidesToScroll: 3,
  arrows: false,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 320,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const CardList = (props) => {
  const {
    title,
    linkDetails,
    list = [],
    type = "",
    parentPath = "",
    customStyles = { containerStyle: {} },
    showArrows = true,
  } = props;

  const sliderRef = useRef(null);

  return (
    <div className={`${styles.container} ${customStyles.containerStyle}`}>
      <div className={styles.cardList}>
        <div className={styles.headerContainer}>
          <h3>{title}</h3>

          <div className={styles.customArrows}>
            <CarousalArrow showArrows={showArrows} sliderRef={sliderRef} />
            {linkDetails && (
              <Link to={linkDetails?.to} className={styles.anchorTag}>
                {linkDetails?.name}
              </Link>
            )}
          </div>
        </div>
        <div
          className={
            styles.imageSliderContainer +
            (type ? " " : " root-slider-container")
          }
        >
          <Slider {...settings} ref={sliderRef}>
            {list?.map((item, index) => (
              <div
                className={styles.customSlideContainer}
                key={`${type ? type : `book`}-${index}`}
              >
                {type === "granth" ? (
                  <BookCard book={item} parentPath={parentPath} />
                ) : (
                  <BlogCard {...item} path={parentPath} />
                )}
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default CardList;
